var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = { key: 0 };
var _hoisted_2 = { class: "text-center" };
var _hoisted_3 = { class: "text-center mt-4" };
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import vaccinazioni from "@/../../EshJSLib/models/form/vaccinazioni.json";
import vaccinazioniCalendar from "@/../../EshJSLib/models/form/vaccinazioniCalendar.json";
import { onMounted, reactive, ref } from "vue";
import vecciniEditCreate from '@/views/Vaccinazioni/vecciniEditCreate.vue';
import vacciniConfidenzialita from "@/views/Vaccinazioni/vacciniConfidenzialita.vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import loadingComponent from "@/components/loadingComponent.vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { Modal } from "flowbite-vue";
import { hasPermission } from "../../../../EshJSLib/services/securityServices";
export default /*#__PURE__*/ _defineComponent({
    __name: 'VaccinazioniPage',
    setup: function (__props) {
        var _this = this;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        var indexgl = ref(null);
        var alertModal = ref(null);
        var modalAddEdit = ref(null);
        var modalConfidenzialita = ref(null);
        var showLoading = ref(false);
        var router = useRouter();
        var isShownModal = reactive({
            alert: false,
            movePage: false,
            confirm: false,
            alertMove: false,
        });
        function movePage() {
            router.push({ path: 'Paypal' });
        }
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                store.fetchVaccini();
                return [2 /*return*/];
            });
        }); });
        function saveAndRefreshVaccini(row) {
            showLoading.value = true;
            store.savePaziente("tbl_vaccinaziones", row.id_vaccinazione)
                .then(function (x) {
                store.fetchVaccini();
                showLoading.value = false;
                alertModal.value.openModal("Dati salvati con successo!", false);
            }, function (error) {
                store.fetchVaccini();
                showLoading.value = false;
                alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
            });
        }
        function action(type, row, index, table) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, id_tipo_licenza;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = type;
                            switch (_a) {
                                case 'add': return [3 /*break*/, 1];
                                case 'pen': return [3 /*break*/, 3];
                                case 'lock': return [3 /*break*/, 5];
                                case 'trash': return [3 /*break*/, 6];
                                case 'info': return [3 /*break*/, 7];
                            }
                            return [3 /*break*/, 8];
                        case 1:
                            id_tipo_licenza = patient.value.sottoscrizione.id_tipo_licenza;
                            return [4 /*yield*/, hasPermission('aggiungivaccini')];
                        case 2:
                            if (_b.sent()) {
                                row = {};
                                row.id_vaccinazione = 0;
                                row.author_id = patient.value.id_paziente;
                                row.id_paziente = patient.value.id_paziente;
                                row.id_livello_confidenzialita = 6;
                                row.vaccinidetails = {};
                                modalAddEdit.value.openModal('', row, 'Aggiungi nuovo vaccino').then(function (input) {
                                    if (input) {
                                        patient.value.tbl_vaccinaziones.push(row);
                                        saveAndRefreshVaccini(row);
                                    }
                                });
                            }
                            else {
                                isShownModal.alert = true;
                            }
                            return [3 /*break*/, 8];
                        case 3: return [4 /*yield*/, hasPermission('modificavaccini')];
                        case 4:
                            if (_b.sent()) {
                                modalAddEdit.value.openModal('', row, 'Modifica il vaccino').then(function (input) {
                                    if (input) {
                                        patient.value.tbl_vaccinaziones.push(row);
                                        saveAndRefreshVaccini(row);
                                    }
                                });
                            }
                            else {
                                isShownModal.alert = true;
                            }
                            return [3 /*break*/, 8];
                        case 5:
                            modalConfidenzialita.value.openModal('', row).then(function (input) {
                                if (input) {
                                    patient.value.tbl_vaccinaziones.push(row);
                                    saveAndRefreshVaccini(row);
                                }
                            });
                            return [3 /*break*/, 8];
                        case 6:
                            row.deleted_at = new Date(Date.UTC(2012, 11, 20, 3, 0, 0));
                            alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then(function (input) {
                                if (input) {
                                    patient.value.tbl_vaccinaziones.push(row);
                                    saveAndRefreshVaccini(row);
                                }
                            });
                            return [3 /*break*/, 8];
                        case 7:
                            axios.get("/farmacoDetails/" + row.vaccinidetails.id_farmaco_codifa).then(function (response) {
                                window.open("/farmacoDetails/" + row.vaccinidetails.id_farmaco_codifa);
                            }, function (error) {
                                alertModal.value.openModal('Nessuna informazione di dettaglio per questo vaccino', false);
                            });
                            return [3 /*break*/, 8];
                        case 8: return [2 /*return*/];
                    }
                });
            });
        }
        var dataModelCompletati = new CollapsableModel();
        return function (_ctx, _cache) {
            return (_unref(patient))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(vecciniEditCreate, {
                        ref_key: "modalAddEdit",
                        ref: modalAddEdit
                    }, null, 512),
                    _createVNode(vacciniConfidenzialita, {
                        ref_key: "modalConfidenzialita",
                        ref: modalConfidenzialita
                    }, null, 512),
                    _createVNode(AlertModal, {
                        ref_key: "alertModal",
                        ref: alertModal
                    }, null, 512),
                    (showLoading.value)
                        ? (_openBlock(), _createBlock(loadingComponent, { key: 0 }))
                        : _createCommentVNode("", true),
                    _createVNode(CollapsibleItem, {
                        data: _unref(vaccinazioni),
                        onRowActions: _cache[0] || (_cache[0] = function (n, r, i) { return action(n, r, i, 'ecluse'); }),
                        onCreateForm: _cache[1] || (_cache[1] = function ($event) { return (action('add', null, null, 'ecluse')); })
                    }, null, 8, ["data"]),
                    _createVNode(CollapsibleItem, { data: _unref(vaccinazioniCalendar) }, null, 8, ["data"]),
                    (isShownModal.alert)
                        ? (_openBlock(), _createBlock(_unref(Modal), {
                            key: 1,
                            onClose: _cache[4] || (_cache[4] = function ($event) { return (isShownModal.alert = false); })
                        }, {
                            body: _withCtx(function () { return [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("Questa sezione non è prevista nella tua sottoscrizione")), 1),
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("button", {
                                        onClick: _cache[2] || (_cache[2] = function ($event) { return (isShownModal.alert = false); }),
                                        type: "button",
                                        class: "text-gray-900 bg-white border border-gray-300 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700"
                                    }, _toDisplayString(_ctx.$t("Annulla")), 1),
                                    _createElementVNode("button", {
                                        onClick: _cache[3] || (_cache[3] = function ($event) { return (movePage()); }),
                                        type: "button",
                                        class: "text-white bg-gray-800 hover:bg-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-700 dark:border-gray-700"
                                    }, _toDisplayString(_ctx.$t("Iscriviti")), 1)
                                ])
                            ]; }),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
